import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withClock from '../../../../shared/components/utils/hoc/withClock';

const PilotClock = styled.span<React.CSSProperties>`
  color: ${Colors['text']};
  font-family: ${Fonts['regular']};
  font-size: ${30 * Screen.widthRatio}px;
  position: absolute;
  right: ${124 * Screen.widthRatio}px;
  top: ${71 * Screen.widthRatio}px;
  z-index: 1;
`;

export default withClock(PilotClock, { displaySeconds: false });
